import request from "./core/index";

// Updated ContactFormData interface with string type for inquiryType and budget
export interface ContactFormData {
  inquiryType: string; // 한글로 된 문의 유형 (쉼표로 구분된 여러 유형 가능)
  duration: number;
  budget: string | number; // Budget can be string or number
  content: string;
  file1?: File | null;
  file2?: File | null;
  companyName: string;
  contactPerson: string;
  email: string;
  phoneNumber: string;
  isNewsLetterAgreed: boolean;
}

// Interface for the JSON payload with base64 encoded files
interface ContactFormJsonPayload {
  inquiryType: string;
  duration: number;
  budget: string;
  content: string;
  companyName: string;
  contactPerson: string;
  email: string;
  phoneNumber: string;
  isNewsLetterAgreed: boolean;
  file1?: {
    fileName: string;
    contentType: string;
    fileSize: number;
    base64Data: string;
  } | null;
  file2?: {
    fileName: string;
    contentType: string;
    fileSize: number;
    base64Data: string;
  } | null;
}

/**
 * Convert File to base64 encoded string
 * @param file File to encode
 * @returns Promise with base64 string
 */
const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove the data URL prefix (e.g., "data:image/jpeg;base64,")
      const base64String = reader.result as string;
      const base64Content = base64String.split(',')[1];
      resolve(base64Content);
    };
    reader.onerror = error => reject(error);
  });
};

/**
 * Submit contact form data to the API using JSON with base64 encoded files
 * @param data Contact form data
 * @returns Promise with API response
 */
export const submitContactForm = async <T>(data: ContactFormData) => {
  const url = `/api/contacts`;
  
  // Create JSON payload
  const payload: ContactFormJsonPayload = {
    inquiryType: data.inquiryType,
    duration: data.duration,
    budget: data.budget.toString(),
    content: data.content,
    companyName: data.companyName,
    contactPerson: data.contactPerson,
    email: data.email,
    phoneNumber: data.phoneNumber,
    isNewsLetterAgreed: data.isNewsLetterAgreed,
    file1: null,
    file2: null
  };
  
  // Encode files to base64 if they exist
  if (data.file1) {
    const base64 = await fileToBase64(data.file1);
    payload.file1 = {
      fileName: data.file1.name,
      contentType: data.file1.type,
      fileSize: data.file1.size,
      base64Data: base64
    };
  }
  
  if (data.file2) {
    const base64 = await fileToBase64(data.file2);
    payload.file2 = {
      fileName: data.file2.name,
      contentType: data.file2.type,
      fileSize: data.file2.size,
      base64Data: base64
    };
  }
  
  console.log('Sending JSON data with encoded files:', 
    payload.file1 ? `file1: ${payload.file1.fileName}` : 'No file1',
    payload.file2 ? `file2: ${payload.file2.fileName}` : 'No file2'
  );
  
  // Send as JSON
  return request.post<T>(url, payload);
}; 